import { TweakwiseItem } from "@jog/types"

import { getGtmIdFromTW } from "../helper"

declare global {
    interface Window {
        dataLayer: Record<string, any>[]
    }
}
const init = () => (window.dataLayer = window.dataLayer || [])
export const gtmPush = (data: any) => {
    init()
    window.dataLayer.push(data)
}
export const gtmHomepage = () => {
    gtmPush({ event: "homepage" })
}
export const gtmEmail = (email: string) => {
    gtmPush({ email })
}
export const adpageHook = <T>(api: string, body: T) => {
    const base = (process.env.NEXT_PUBLIC_ADPAGE_TAGGING || "").replace(/\/$/, "")
    if (!base) return
    return fetch(base + "/" + api.replace(/^\//, ""), {
        method: "POST",
        body: JSON.stringify(body),
    })
}
export const getImpressions = (items: TweakwiseItem[]) =>
    items.map((product, index) => {
        const category = product.attributes.find((attribute) => attribute.name === "categoryAsUrl")?.values?.[0] || ""
        return {
            id: getGtmIdFromTW(product),
            name: product.title,
            price: product.price,
            brand: product.brand,
            category,
            variant: "",
            list: category,
            position: index + 1,
        }
    })
